import { render, staticRenderFns } from "./GegContratC5.vue?vue&type=template&id=20169188"
import script from "./GegContratC5.vue?vue&type=script&lang=js"
export * from "./GegContratC5.vue?vue&type=script&lang=js"
import style0 from "./GegContratC5.vue?vue&type=style&index=0&id=20169188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports